import { lazy } from 'react'

export const DataVariant2 = lazy(() => import('./DataVariant2'))
